import { Component, OnInit } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, QuerySnapshot, DocumentChangeAction, DocumentReference } from '@angular/fire/firestore';
import { map, flatMap } from 'rxjs/operators';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AgregarSeguridadDepartamentoComponent } from './agregar-seguridad-departamento/agregar-seguridad-departamento.component'
import { EditarSeguridadDepartamentoComponent } from './editar-seguridad-departamento/editar-seguridad-departamento.component';

import { SecurityService } from '../../../services/security/security.service';
import { ToastService } from '../../../services/toast/toast.service';
import { firestore } from 'firebase';

@Component({
  selector: 'app-reporte-seguridad-departamento',
  templateUrl: './reporte-seguridad-departamento.component.html',
  styleUrls: ['./reporte-seguridad-departamento.component.css']
})
export class ReporteSeguridadDepartamentoComponent implements OnInit {

  public services: Array<any> = [];
  public idCodominium: String = localStorage.getItem('condominio').replace(/['"]+/g, '');
  public loading = true;

  constructor(
    public activeModal: NgbActiveModal,
    private firestore: AngularFirestore,
    private modalService: NgbModal,
    private securityService: SecurityService,
    public toastService: ToastService,
  ) { }

  // changeValueStatus($obj, area){
  //   console.log($obj);
  //   console.log(area);
  // }

  changeValueStatus(service){
    console.log(service);
    let ref = service.ref as DocumentReference
    ref.update({status: service.status, lastUpdate: firestore.Timestamp.now(),})
    .then(() => {
      this.toastService.show('¡Estatus actualizado exitosamente!', { classname: 'bg-success text-light'});
    })
    .catch((e) => {
      console.log(e);
      this.toastService.show('No se pudo actualizar estatus', { classname: 'bg-danger text-light'});
    })
  }

  deleteService(service){
    if(window.confirm(`¿Desea borrar servicio ${service.name} de departamento para seguridad?`)){
      let ref = service.ref as DocumentReference;
      ref.delete()
      .then(() => {
        this.toastService.show('¡Servicio borrado exitosamente!', { classname: 'bg-success text-light'});
      })
      .catch((e) => {
        console.log(e);
        this.toastService.show('No se pudo borrar servicio', { classname: 'bg-danger text-light'});
      })
    }
  }

  getSecurityFlats(){
    this.services = [];
    let ref = this.securityService.getSecurityFlats(this.idCodominium).ref;
    // ref.orderBy('name', 'asc')
    this.firestore.collection(ref.path, _ref => 
      _ref.orderBy('name', 'asc') 
    )
    .snapshotChanges()
    .pipe(map(services =>
      services.map(
        c => ({ 
          id: c.payload.doc.id, 
          ref: c.payload.doc.ref,
          ...c.payload.doc.data() as DocumentChangeAction<any> 
        })
      )
    ))
    .subscribe(services => {
      console.log("all ", services);
      this.services = services;
      this.loading = false;
    });
  }

  openModalCreateNewService(){
    const modalRef = this.modalService.open(AgregarSeguridadDepartamentoComponent, {
      // size: 'lg'
    });

    // modalRef.componentInstance.text = 'HOLAAAAA';

    modalRef.result.then((result) => {
      console.log(result);
      // this.getProducts();
    })
    .catch((error) => {
      console.log(error);
      // this.getProducts();
    });
  }

  openModalEditFlat(service){

    const modalRef = this.modalService.open(EditarSeguridadDepartamentoComponent, {

    });

    modalRef.componentInstance.service = service;

    modalRef.result.then((result) => {
      console.log(result);
      // this.getProducts();
    })
    .catch((error) => {
      console.log(error);
      // this.getProducts();
    });

  }

  ngOnInit(): void {
    this.getSecurityFlats();
  }

}
